
import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { myListingsIconUrl } from '../../../utils/staticAssets'

class Icon extends React.Component {
  render () {
    return (
      <div className='flex flex-col items-center text-center' style={{ cursor: 'pointer', fontSize: '12px', textTransform: 'none' }}>
        <img className='w-24' src={myListingsIconUrl(this.props.iconName)} alt={this.props.content} />
        <MediaQuery minWidth={992}>
          <div className='pt-10'> {this.props.content} </div>
        </MediaQuery>
      </div>
    )
  }
}

Icon.propTypes = {
  content: PropTypes.string,
  iconName: PropTypes.string
}

export default Icon
